import React from "react";
//convert to material ui v5
// import { makeStyles } from "@mui/styles";
// import { makeStyles } from "@mui/styles";
// import List from "@mui/material/List";

import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";

import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
import ListItemText from "@mui/material/ListItemText";

import { orderBy } from "lodash";


export default function DataThruList(props) {
  const classes = {
    root: {
      width: "100%",
      maxWidth: 460,
      // backgroundColor: theme.palette.background.paper,
      position: "relative",
      overflow: "auto",
      maxHeight: 400,
    },
    listSection: {
      backgroundColor: "inherit",
    },
    ul: {
      backgroundColor: "inherit",
      padding: 0,
    },
  };
  const sortedPathObject = orderBy(props.data, ["warehouse_name"], "asc");

  return (
    <React.Fragment>
      <List sx={classes.root} subheader={<li />} dense={true}>
        {sortedPathObject.map((e, idx) => {
          return (
            <ListItem key={idx}>
              <ListItemText
                primary={e.warehouse_name}
                secondary={e.max_thru_date.replace(/-/g, '/')}
              />
            </ListItem>
          );
        })}
      </List>
    </React.Fragment>
  );
}
